import React from "react";
import NavBar from "../../components/navBar/NavBar";
import SignatureCanvas from "react-signature-canvas";
import "../../assets/style/style.css";
import axios from "axios";


//import ptBr from "moment/locale/pt-br";
import moment from "moment";
import MaskedInput from "react-text-mask";


import ImgCard from "../../components/imgCard/ImgCard.jsx";
import "react-dates/initialize";

import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import srcImgTomada1 from "../../img/tomada-1.jpg";
import srcImgTomada2 from "../../img/tomada-2.jpg";

//import './App.css';

require("dotenv").config();

const url = process.env.REACT_APP_API_TASK;

class ActivityClientNoEdit extends React.Component {
  constructor(props) {
    super(props);
   

    this.state = {
      data_chegada: "",
      pendencia: "",
      idViabilidade: "",
      empresa: "",
      endereco: "",
      bairro: "",
      complemento: "",
      email: "",
      telefone: "",
      telefone_fixo: "",
      tipo_servico: "",
      diagnostico: "",
      diagnosticoOutro: "",
      solucao: "",
      solucaoOutro: "",
      load: "false",
      imgDirecaoRepetidora: [],
      imgDirecaoRepetidoraText: [],
      imgTopoLocal: [],
      imgTopoLocalText: [],
      imgFixacaoAntena: [],
      imgFixacaoAntenaText: [],
      imgPercursoCabeamento: [],
      imgPercursoCabeamentoText: [],
      imgEntregaLink: [],
      imgEntregaLinkText: [],
      imgAntenaFixada: [],
      imgAntenaFixadaText: [],
      imgDirecaoEnlace: [],
      imgDirecaoEnlaceText: [],
      imgCabeamento: [],
      imgCabeamentoText: [],
      imgRbPoe: [],
      imgRbPoeText: [],
      imgTesteLink: [],
      imgTesteLinkText: [],
      imgAntenaRemovida: [],
      imgAntenaRemovidaText: [],
      imgEquipamentoAtuado: [],
      imgEquipamentoAtuadoText: [],
      tipo_suporte_outro: "",
      descricao: "",
      estacionamento: "",
      tensao: "",
      estimativa_cabo_metros: "",
      rg: "",
      showAssinatura: "Desabilitar Assinatura",
      assinatura: "",
      status_assinatura: ""
    };
  }
  componentDidMount() {
    const tokenLocal = localStorage.getItem("token");
    this.getActivityClient(this.props.match.params.id, tokenLocal);

  
  }



  getActivityClient = (id, token) => {
    const objForm = { id: id, token: token };
    axios
      .post(
        `${url}/atividade_cliente`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        if (response.data.rat_client["0"].data_chegada) {
          this.setState({
            date: moment(response.data.rat_client["0"].data_chegada)
          });
        }

        this.setState({
          motivo_servico_interrompido: response.data.rat_client["0"].motivo_servico_interrompido,
          servico_interrompido:response.data.rat_client["0"].servico_interrompido,
          idViabilidade: response.data.rat_client["0"].id_viabilidade,
          empresa: response.data.viabilidade[0].empresa,
          endereco: response.data.viabilidade[0].endereco,
          bairro: response.data.viabilidade[0].bairro,
          complemento: response.data.viabilidade[0].complemento,
          telefone: response.data.viabilidade[0].telefone,
          numero: response.data.viabilidade[0].numero,
          email: response.data.viabilidade[0].contato_questionario_email,
          //date: moment(response.data.rat_client["0"].data_chegada),
          hora_chegada: response.data.rat_client["0"].hora_chegada,
          hora_liberacao: response.data.rat_client["0"].hora_liberacao,
          hora_saida: response.data.rat_client["0"].hora_saida,
          descricao: response.data.rat_client["0"].descricao,
          tipo_servico: response.data.rat_client["0"].tipo_servico,
          escada: response.data.rat_client["0"].escada,
          tipo_escada: response.data.rat_client["0"].tipo_escada,
          observacao: response.data.rat_client["0"].observacao,
          estacionamento: response.data.rat_client["0"].estacionamento,
          tensao: response.data.rat_client["0"].tensao,
          tomada: response.data.rat_client["0"].tomada,
          acessoCobertura: response.data.rat_client["0"].acesso_cobertura,
          tipo_suporte: response.data.rat_client["0"].tipo_suporte,
          tipo_suporte_outro: response.data.rat_client["0"].tipo_suporte_outro,
          estimativa_cabo_metros: response.data.rat_client["0"].estimativa_cabo_metros,
          imgDirecaoRepetidora: response.data.fotosDirecaoRepetidora,
          imgDirecaoRepetidoraText: response.data.fotosDirecaoRepetidora,
          imgTopoLocal: response.data.fotosTopoLocal,
          imgTopoLocalText: response.data.fotosTopoLocal,
          imgFixacaoAntena: response.data.fotosFixacaoAntena,
          imgFixacaoAntenaText: response.data.fotosFixacaoAntena,
          imgPercursoCabeamento: response.data.fotosPercursoCabeamento,
          imgPercursoCabeamentoText: response.data.fotosPercursoCabeamento,
          imgEntregaLink: response.data.fotosEntregaLink,
          imgEntregaLinkText: response.data.fotosEntregaLink,
          observacao_adicionais:response.data.rat_client["0"].observacao_adicionais,
          imgAntenaFixada: response.data.fotosAntenaFixada,
          imgAntenaFixadaText: response.data.fotosAntenaFixada,
          imgDirecaoEnlace: response.data.fotosDirecaoEnlace,
          imgDirecaoEnlaceText: response.data.fotosDirecaoEnlace,
          imgCabeamento: response.data.fotosCabeamento,
          imgCabeamentoText: response.data.fotosCabeamento,
          imgRbPoe: response.data.fotosRbPoe,
          imgRbPoeText: response.data.fotosRbPoe,
          imgTesteLink: response.data.fotosTesteLink,
          imgTesteLinkText: response.data.fotosTesteLink,
          imgAntenaRemovida: response.data.fotosAntenaRemovida,
          imgAntenaRemovidaText: response.data.fotosAntenaRemovida,
          imgEquipamentoAtuado: response.data.fotosAntenaEquipamentoAtuado,
          imgEquipamentoAtuadoText: response.data.fotosAntenaEquipamentoAtuado,
          instalacaoConcluida:response.data.rat_client["0"].instalacao_concluida,
          retiradaPendente: response.data.rat_client["0"].retirada_pendente,
          descricaoProblema: response.data.rat_client["0"].descricao_problema,
          solucao: response.data.rat_client["0"].solucao,
          solucaoOutro: response.data.rat_client["0"].solucao_outro,
          diagnostico: response.data.rat_client["0"].diagnostico,
          diagnosticoOutro: response.data.rat_client["0"].diagnostico_outro,
          velocidade: response.data.rat_client["0"].velocidade,
          responsavel: response.data.rat_client["0"].responsavel,
          assinatura: response.data.rat_client["0"].assinatura,
          status_assinatura: response.data.rat_client["0"].status_assinatura,
          tecnico: response.data.rat_client["0"].tecnico,
          status: response.data.rat_client["0"].status
        });

        if (response.data.viabilidade[0].email) {
          this.setState({
            email: response.data.viabilidade[0].email
          });
        }

        if (this.state.velocidade > 1000) {
          let velocidade = this.state.velocidade / 1024;
          this.setState({
            velocidade: velocidade,
            formatVelocidade: "Gbps"
          });
        } else {
          this.setState({
            formatVelocidade: "Mbps"
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  tipo_servico() {
    if (this.state.tipo_servico === "vistoria") {
      return (
        <React.Fragment>
          <div className="form-group">
            <label htmlFor="estacionamento">
              <i className="fas fa-exclamation-triangle" />

              {!this.state.estacionamento ? (
                <span className="text-danger"> Estacionamento ? * </span>
              ) : (
                <React.Fragment>Estacionamento ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="estacionamento"
                id="estacionamento1"
                value="sim"
                
                checked={this.state.estacionamento === "sim"}
              />
              <label className="form-check-label" htmlFor="estacionamento1">
                Sim
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="estacionamento"
                id="estacionamento2"
                value="nao"
                
                checked={this.state.estacionamento === "nao"}
              />
              <label className="form-check-label" htmlFor="estacionamento2">
                Não
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="tensao">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.tensao ? (
                <span className="text-danger"> Tensão Elétrica ? * </span>
              ) : (
                <React.Fragment>Tensão Elétrica ?</React.Fragment>
              )}
            </label>

            <div className="form-check">
              <input
                //defaultChecked
                className="form-check-input"
                type="radio"
                name="tensao"
                id="tensao1"
                value="127"
       
                checked={this.state.tensao === "127"}
              />
              <label className="form-check-label" htmlFor="tensao1">
                127 V
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tensao"
                id="tensao2"
                value="220"
              
                checked={this.state.tensao === "220"}
              />
              <label className="form-check-label" htmlFor="tensao2">
                220 V
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="tomada">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.tomada ? (
                <span className="text-danger">Padrão de Tomada local ? *</span>
              ) : (
                <React.Fragment>Padrão de Tomada local ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tomada"
                id="tomada1"
                value="tomada1"
                
                checked={this.state.tomada === "tomada1"}
              />
              <label className="form-check-label" htmlFor="tomada1">
                Tomada 1 -
                <img src={srcImgTomada1} alt="tomada 1" />
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tomada"
                id="tomada2"
                value="tomada2"
                
                checked={this.state.tomada === "tomada2"}
              />
              <label className="form-check-label" htmlFor="tomada2">
                Tomada 2 - <img src={srcImgTomada2} alt="tomada 2" />
              </label>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="formasAcesso">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.acessoCobertura ? (
                <span className="text-danger">
                  Formas de acesso à cobertura do local ?*
                </span>
              ) : (
                <React.Fragment>
                  Formas de acesso à cobertura do local ?
                </React.Fragment>
              )}
            </label>
            <textarea
              className="form-control"
              id="formasAcesso"
              rows="3"
              
              name="acessoCobertura"
              value={this.state.acessoCobertura}
            />
          </div>
          <div className="form-group">
            <label>
                <React.Fragment>Foto da direção da repetidora</React.Fragment>
            </label>
            
            <div className="form-group containerImg">
              {this.state.imgDirecaoRepetidora &&
                this.state.imgDirecaoRepetidora.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                       
                        fieldName="imgDirecaoRepetidoraText"
                        idName={i}
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              Foto 360 no topo do local
              )}
            </label>
            
            <div className="form-group containerImg">
              {this.state.imgTopoLocal &&
                this.state.imgTopoLocal.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        disabledClose="true"
                        fieldName="imgTopoLocalText"
                        idName={i}
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              Foto local fixação antena
              )}
            </label>
            <div className="form-group containerImg">
              {this.state.imgFixacaoAntena &&
                this.state.imgFixacaoAntena.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgFixacaoAntenaText"
                        idName={i}
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="tipoSuporte">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.tipo_suporte.length > 0 ? (
                <span className="text-danger"> Tipo de Suporte ? * </span>
              ) : (
                <React.Fragment>Tipo de Suporte ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tipo_suporte"
                id="tipo_suporte1"
                value="tripe"
                
                checked={this.state.tipo_suporte === "tripe"}
              />
              <label className="form-check-label" htmlFor="tipo_suporte1">
                Tripé
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tipo_suporte"
                id="tipo_suporte2"
                value="parede"
                
                checked={this.state.tipo_suporte === "parede"}
              />
              <label className="form-check-label" htmlFor="tipo_suporte2">
                Parede
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tipo_suporte"
                id="tipo_suporte3"
                value="outro"
          
                checked={this.state.tipo_suporte === "outro"}
              />
              <label
                className="form-check-label"
                htmlFor="tipo_suporte3"
              
              >
                Outros
                {!this.state.tipo_suporte_outro.length > 0 &&
                  this.state.tipo_suporte === "outro" && (
                    <span className="text-danger"> * </span>
                  )}
              </label>
            </div>
            {this.state.tipo_suporte === "outro" && (
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="inputAddress2"
                  name="tipo_suporte_outro"
                  
                  value={this.state.tipo_suporte_outro}
                />
              </div>
            )}
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
                Foto de percurso do cabeamento
              )}
            </label>

            <div className="form-group containerImg">
              {this.state.imgPercursoCabeamento &&
                this.state.imgPercursoCabeamento.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgPercursoCabeamentoText"
                        idName={i}
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="estimativaCabo">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.estimativa_cabo_metros ? (
                <span className="text-danger">
                  Estimativa do cabo em metros:*
                </span>
              ) : (
                <React.Fragment>Estimativa do cabo em metros:</React.Fragment>
              )}
            </label>
            <input
              type="text"
              className="form-control"
              id="estimativaCabo"
              
              name="estimativa_cabo_metros"
              defaultValue={this.state.estimativa_cabo_metros}
            />
          </div>
          <div className="form-group">
            <label>
              Foto de entrega do link
              )}
            </label>
            <div className="form-group containerImg">
              {this.state.imgEntregaLink &&
                this.state.imgEntregaLink.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgEntregaLinkText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
        </React.Fragment>
      );
    } else if (this.state.tipo_servico === "instalacao") {
      return (
        <React.Fragment>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.instalacaoConcluida ? (
                <span className="text-danger">
                  Instalação concluída e funcionamento perfeito ? *
                </span>
              ) : (
                <React.Fragment>
                  Instalação concluída e funcionamento perfeito ?
                </React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="instalacaoConcluida"
                id="instalacaoConcluida1"
                value="sim"
                
                defaultChecked={this.state.instalacaoConcluida === "sim" || ""}
              />
              <label
                className="form-check-label"
                htmlFor="instalacaoConcluida1"
              >
                Sim
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="instalacaoConcluida"
                id="instalacaoConcluida2"
                value="nao"
                
                defaultChecked={this.state.instalacaoConcluida === "nao" || ""}
              />
              <label
                className="form-check-label"
                htmlFor="instalacaoConcluida2"
              >
                Não
              </label>
            </div>
          </div>
          <div className="form-group">
            <label>
                Foto antena fixada
            </label>
            <div className="form-group containerImg">
              {this.state.imgAntenaFixada &&
                this.state.imgAntenaFixada.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgAntenaFixadaText"
                        idName={i}
                      
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              Foto direção enlace
            </label>
            <div className="form-group containerImg">
              {this.state.imgDirecaoEnlace &&
                this.state.imgDirecaoEnlace.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgDirecaoEnlaceText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              Foto cabeamento
            </label>
            <div className="form-group containerImg">
              {this.state.imgCabeamento &&
                this.state.imgCabeamento.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgCabeamentoText"
                        idName={i}
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              Foto RB e POE identificado
            </label>
            <div className="form-group containerImg">
              {this.state.imgRbPoe &&
                this.state.imgRbPoe.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgRbPoeText"
                        idName={i}
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
             Foto teste link quando aplicado
            </label>
            <div className="form-group containerImg">
              {this.state.imgTesteLink &&
                this.state.imgTesteLink.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgTesteLinkText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
        </React.Fragment>
      );
    } else if (this.state.tipo_servico === "retirada") {
      return (
        <React.Fragment>
          <div className="form-group">
            <label>
                Retirada concluída sem pendências ?         
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="retiradaPendente"
                id="retiradaPendente1"
                value="sim"
                
                checked={this.state.retiradaPendente === "sim" || ""}
              />
              <label className="form-check-label" htmlFor="retiradaPendente1">
                Sim
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="retiradaPendente"
                id="retiradaPendente2"
                value="nao"
                
                checked={this.state.retiradaPendente === "nao" || ""}
              />
              <label className="form-check-label" htmlFor="retiradaPendente2">
                Não
              </label>
            </div>
          </div>
          <div className="form-group">
            <label>
                Foto local antena removida
            </label>
            
            <div className="form-group containerImg">
              {this.state.imgAntenaRemovida &&
                this.state.imgAntenaRemovida.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgAntenaRemovidaText"
                        idName={i}
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
        </React.Fragment>
      );
    } else if (
      this.state.tipo_servico === "manutencao_preventiva" ||
      this.state.tipo_servico === "manutencao_corretiva" ||
      this.state.tipo_servico === "manutencao_emergencial"
    ) {
      return (
        <React.Fragment>
          <div className="form-group">
            <label htmlFor="exampleFormControlTextarea1">
                Descrição detalhada do problema
            </label>
            <textarea
              name="descricaoProblema"
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              value={this.state.descricaoProblema}
            />
          </div>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.diagnostico ||
              (this.state.diagnostico === "outro" &&
                !this.state.diagnosticoOutro) ? (
                <span className="text-danger">Diagnóstico do Serviço ? * </span>
              ) : (
                <React.Fragment>Diagnóstico do Serviço ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico1"
                value="cabo rompido"
                
                checked={this.state.diagnostico === "cabo rompido"}
              />
              <label className="form-check-label" htmlFor="diagnostico1">
                Cabo rompido
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico2"
                value="poe defeituoso"
                
                checked={this.state.diagnostico === "poe defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico2">
                Poe defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico3"
                value="radio defeituoso"
                
                checked={this.state.diagnostico === "radio defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico3">
                Rádio defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico4"
                value="conector defeituoso"
                
                checked={this.state.diagnostico === "conector defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico4">
                Conector defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico5"
                value="rb defeituosa"  
                checked={this.state.diagnostico === "rb defeituosa"}
              />
              <label className="form-check-label" htmlFor="diagnostico5">
                RB defeituosa
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico6"
                value="problema elétrico"
                
                checked={this.state.diagnostico === "problema elétrico"}
              />
              <label className="form-check-label" htmlFor="diagnostico6">
                Problema elétrico
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico7"
                value="antena defeituosa"
                
                checked={this.state.diagnostico === "antena defeituosa"}
              />
              <label className="form-check-label" htmlFor="diagnostico7">
                Antena defeituosa
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico8"
                value="outro"
                
                checked={this.state.diagnostico === "outro"}
              />
              <label className="form-check-label" htmlFor="diagnostico8">
                {!this.state.diagnosticoOutro &&
                this.state.diagnostico === "outro" ? (
                  <span className="text-danger"> Outro * </span>
                ) : (
                  <React.Fragment>Outro</React.Fragment>
                )}
              </label>
            </div>

            {this.state.diagnostico === "outro" && (
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="inputAddress2"
                  name="diagnosticoOutro"
                  value={this.state.diagnosticoOutro}
                  
                />
              </div>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.solucao ||
              (this.state.solucao === "outro" && !this.state.solucaoOutro) ? (
                <span className="text-danger"> Solução ? * </span>
              ) : (
                <React.Fragment>Solução ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao1"
                value="substituição do cabeamento todo"
                
                checked={
                  this.state.solucao === "substituição do cabeamento todo"
                }
              />
              <label className="form-check-label" htmlFor="solucao1">
                Substituição do cabeamento todo
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao2"
                value="substituição do cabo porta poe"
                
                checked={
                  this.state.solucao === "substituição do cabo porta poe"
                }
              />
              <label className="form-check-label" htmlFor="solucao2">
                Substituição do cabo porta POE
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao3"
                value="substituição da fonte poe"
                
                checked={this.state.solucao === "substituição da fonte poe"}
              />
              <label className="form-check-label" htmlFor="solucao3">
                Substituição da fonte POE
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao4"
                value="substituiçao do radio"
                
                checked={this.state.solucao === "substituiçao do radio"}
              />
              <label className="form-check-label" htmlFor="solucao4">
                Substituiçao do Radio
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao5"
                value="substituiçao antena"
                
                checked={this.state.solucao === "substituiçao antena"}
              />
              <label className="form-check-label" htmlFor="solucao5">
                Substituiçao Antena
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao6"
                value="substituição de estabilizador/nobreak"
                
                checked={
                  this.state.solucao === "substituição de estabilizador/nobreak"
                }
              />
              <label className="form-check-label" htmlFor="solucao6">
                Substituição de Estabilizador/Nobreak
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao7"
                value="substituição da fonte conversora ac/dc"
                
                checked={
                  this.state.solucao ===
                  "substituição da fonte conversora ac/dc"
                }
              />
              <label className="form-check-label" htmlFor="solucao7">
                Substituição da fonte conversora AC/DC
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao8"
                value="outro"
                
                checked={this.state.solucao === "outro"}
              />
              <label className="form-check-label" htmlFor="solucao8">
                {!this.state.solucaoOutro && this.state.solucao === "outro" ? (
                  <span className="text-danger"> Outro * </span>
                ) : (
                  <React.Fragment>Outro</React.Fragment>
                )}
              </label>
            </div>
            {this.state.solucao === "outro" && (
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="inputAddress2"
                  name="solucaoOutro"
                  value={this.state.solucaoOutro}
                  
                />
              </div>
            )}
          </div>
          <div className="form-group">
            <label>
              Foto local/equipamento atuado
              )}
            </label>
            
            <div className="form-group containerImg">
              {this.state.imgEquipamentoAtuado &&
                this.state.imgEquipamentoAtuado.map((img, i) =>
                  img.foto && (
                    <div key={i}>
                      <ImgCard
                        disabledClose="true"
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        fieldName="imgEquipamentoAtuadoText"
                        idName={i}
                      />
                    </div>
                  ) 
                )}
            </div>
          </div>
        </React.Fragment>
      );
    }
  }

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast={`/taskhistory`} />
        <div className="container-fluid container_body">
          <div className="containerCard">
            {this.state.status === "concluido" && (
              <React.Fragment>
                <div>
                  <div className="d-flex justify-content-center">
                    <div className="p-2 bd-highlight align-self-center">
                      <i
                        className="fas fa-check-circle fa-2x"
                        style={{ color: "green" }}
                      />
                    </div>
                    <div className="p-2 bd-highlight align-self-center">
                      <b> Rat Concluída</b>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
            <div className="card marginTop6">
              <h5 className="card-header">Informaçoes do Cliente</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="id">ID Viabilidade</label>
                  <input
                    type="text"
                    className="form-control"
                    id="id"
                    defaultValue={this.state.idViabilidade}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Empresa</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.empresa}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="endereco">Endereço</label>
                  <input
                    type="text"
                    className="form-control"
                    id="endereco"
                    defaultValue={this.state.endereco}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Número</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputAddress2"
                    defaultValue={this.state.numero}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="complemento">Complemento</label>
                  <input
                    type="text"
                    className="form-control"
                    id="complemento"
                    defaultValue={this.state.complemento}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="bairro">Bairro</label>
                  <input
                    type="text"
                    className="form-control"
                    id="bairro"
                    defaultValue={this.state.bairro}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="telefone">Telefone</label>
                  <input
                    type="text"
                    className="form-control"
                    id="telefone"
                    defaultValue={this.state.telefone}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="velocidade">Velocidade</label>
                  <input
                    type="text"
                    className="form-control"
                    id="velocidade"
                    //defaultValue={`${this.state.velocidade} Mbps`}
                    value={` ${this.state.velocidade} ${this.state.formatVelocidade}`}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">
                    {!this.state.email ? (
                      <span className="text-danger"> E-mail * </span>
                    ) : (
                      <React.Fragment>E-mail</React.Fragment>
                    )}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    name="email"
                    
                    defaultValue={this.state.email}
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Data</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="dataChegada">Data da Chegada</label>
                  <br />
                  <SingleDatePicker
                    date={this.state.date} // momentPropTypes.momentObj or null
                    onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                    focused={this.state.focused} // PropTypes.bool
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                    id="your_unique_id" // PropTypes.string.isRequired,
                    displayFormat="DD/MM/YYYY"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    {!this.state.hora_chegada ? (
                      <span className="text-danger">
                        {" "}
                        Horário da Chegada *{" "}
                      </span>
                    ) : (
                      <React.Fragment> Horário da Chegada </React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_chegada"
                    onBlur={() => {}}
                
                    value={this.state.hora_chegada}
                    
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    {!this.state.hora_saida ? (
                      <span className="text-danger"> Horário de Saída * </span>
                    ) : (
                      <React.Fragment>Horário de Saída</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_saida"
                    onBlur={() => {}}
                    
                    value={this.state.hora_saida}
                    
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    {!this.state.hora_liberacao ? (
                      <span className="text-danger">
                        {" "}
                        Horário de Liberação *{" "}
                      </span>
                    ) : (
                      <React.Fragment>Horário de Liberação</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_liberacao"
                    onBlur={() => {}}
                    value={this.state.hora_liberacao}
                    
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Descrição Serviço</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="descricaoDetalhada">
                    Descrição (auto preenchida)
                  </label>
                  <textarea
                    className="form-control"
                    id="descricaoDetalhada"
                    rows="12"
                    name="descricao"
                    
                    value={this.state.descricao}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Tipo de Serviço</label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico1"
                      value="vistoria"
                      checked={this.state.tipo_servico === "vistoria" || ""}
                    
                      disabled
                    />
                    <label className="form-check-label" htmlFor="tipo_servico1">
                      Vistoria
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico2"
                      value="instalacao"
                      
                      checked={this.state.tipo_servico === "instalacao"}
                    />
                    <label className="form-check-label" htmlFor="tipo_servico2">
                      Instalação
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico3"
                      value="retirada"
                      
                      checked={this.state.tipo_servico === "retirada"}
                    />
                    <label className="form-check-label" htmlFor="tipo_servico3">
                      Retirada
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico4"
                      value="manutencao_preventiva"
                      checked={
                        this.state.tipo_servico === "manutencao_preventiva"
                      }
                      
                    />
                    <label className="form-check-label" htmlFor="tipo_servico4">
                      Manutenção Preventiva
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tiposervico5"
                      value="manutencao_corretiva"
                      checked={
                        this.state.tipo_servico === "manutencao_corretiva"
                      }
                      
                    />
                    <label className="form-check-label" htmlFor="tiposervico5">
                      Manutenção Corretiva
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico6"
                      value="manutencao_emergencial"
                      checked={
                        this.state.tipo_servico === "manutencao_emergencial"
                      }
                      
                    />
                    <label className="form-check-label" htmlFor="tipo_servico6">
                      Manutenção Emergencial
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="descricaoDetalhada">
                    Serviço interrompido ?
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="servico_interrompido"
                      id="servico_interrompido1"
                      value="1"
                      checked={this.state.servico_interrompido === "1"}
                      
                    />
                    <label
                      className="form-check-label"
                      htmlFor="servico_interrompido1"
                    >
                      Sim
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="servico_interrompido"
                      id="servico_interrompido2"
                      value="0"
                      
                      checked={this.state.servico_interrompido === "0"}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="servico_interrompido2"
                    >
                      Não
                    </label>
                  </div>
                </div>
                {this.state.servico_interrompido === "1" && (
                  <div className="form-group">
                    <label htmlFor="descricaoDetalhada">
                      {!this.state.motivo_servico_interrompido ? (
                        <span className="text-danger">
                          Motivo do serviço interrompido ? *
                        </span>
                      ) : (
                        <React.Fragment>
                          Motivo do serviço interrompido ?
                        </React.Fragment>
                      )}
                    </label>
                    <textarea
                      className="form-control"
                      id="motivo_servico_interrompido"
                      rows="12"
                      name="motivo_servico_interrompido"
                      
                      value={this.state.motivo_servico_interrompido}
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>
                    {!this.state.escada ? (
                      <span className="text-danger">
                        Será preciso de escada *
                      </span>
                    ) : (
                      <React.Fragment>Será preciso de escada</React.Fragment>
                    )}
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="escada"
                      id="escada1"
                      value="sim"
                      checked={this.state.escada === "sim" || ""}
                      
                    />
                    <label className="form-check-label" htmlFor="escada1">
                      Sim
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="escada"
                      id="escada2"
                      value="nao"
                      
                      checked={this.state.escada === "nao"}
                    />
                    <label className="form-check-label" htmlFor="escada2">
                      Não
                    </label>
                  </div>
                </div>
                {this.state.escada === "sim" && (
                  <div className="form-group">
                    <label>
                      {!this.state.tipo_escada ? (
                        <span className="text-danger">
                          Quantos metros de escada ? *{" "}
                        </span>
                      ) : (
                        <React.Fragment>
                          Quantos metros de escada ?
                        </React.Fragment>
                      )}
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipo_escada"
                        id="tipo_escada1"
                        value="1"
                        checked={this.state.tipo_escada === "1" || ""}
                        
                      />
                      <label
                        className="form-check-label"
                        htmlFor="tipo_escada1"
                      >
                        1 metro
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipo_escada"
                        id="tipo_escada2"
                        value="3"
                        checked={this.state.tipo_escada === "3" || ""}
                        
                      />
                      <label
                        className="form-check-label"
                        htmlFor="tipo_escada2"
                      >
                        3 metros
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipo_escada"
                        id="tipo_escada3"
                        value="6"
                        checked={this.state.tipo_escada === "6" || ""}
                        
                      />
                      <label
                        className="form-check-label"
                        htmlFor="tipo_escada3"
                      >
                        6 metros
                      </label>
                    </div>
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="observacao">
                    {!this.state.observacao ? (
                      <span className="text-danger"> Observação * </span>
                    ) : (
                      <React.Fragment>Observação</React.Fragment>
                    )}
                  </label>
                  <textarea
                    className="form-control"
                    id="observacao"
                    rows="3"
                    name="observacao"
                    
                    value={this.state.observacao}
                  />
                </div>
                {this.tipo_servico()}

                <div className="form-group">
                  <label htmlFor="obsAdicionais">
                    <i className="fas fa-exclamation-triangle" />
                    {!this.state.observacao_adicionais ? (
                      <span className="text-danger">
                        Observação Adicionais *
                      </span>
                    ) : (
                      <React.Fragment>Observação Adicionais</React.Fragment>
                    )}
                  </label>
                  <textarea
                    className="form-control"
                    id="obsAdicionais"
                    rows="3"
                    
                    name="observacao_adicionais"
                    value={this.state.observacao_adicionais}
                  />
                </div>
              </div>
            </div>

            <div className="card marginTop6">
              <h5 className="card-header">Responsável </h5>
              <div className="card-body">
                <div className="form-group">
                  <label>
                    {!this.state.assinatura && !this.state.status_assinatura ? (
                      <span className="text-danger"> Assinatura * </span>
                    ) : (
                      <React.Fragment>Assinatura</React.Fragment>
                    )}
                  </label>

                  {this.state.assinatura ? (
                    <div>
                      <img
                        src={this.state.assinatura}
                        width="100%"
                        height="500px"
                        className="sigCanvas "
                        alt="assinatura"
                      />
                     
                    </div>
                  ) : (
                    <div>
                      <div
                        style={{
                          display:
                            this.state.showAssinatura !== "Habilitar Assinatura"
                              ? "block"
                              : "none"
                        }}
                      >
                        <SignatureCanvas
                          ref={ref => {
                            this.sigCanvas = ref;
                          }}
                          penColor="black"
                          canvasProps={{
                            //height: 500,
                            className: "sigCanvas border1 size100"
                          }}
                          clearOnResize={true}
                        />
                      </div>
                      <input
                        type="button"
                        
                        value="Limpar"
                        className="btn btn-danger marginRight2 mt-2"
                      />

                      <input
                        type="button"
                        value={this.state.showAssinatura}
                        refs="showAssinatura"
                        className="btn btn-primary marginRight2 mt-2"
                   
                      />
                      <input
                        type="button"
                        
                        value="Sem Assinatura"
                        className="btn btn-danger marginRight2 mt-2"
                      />
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="responsavel">
                    {!this.state.responsavel ? (
                      <span className="text-danger">
                        Nome do Cliente / Responsável *
                      </span>
                    ) : (
                      <React.Fragment>
                        Nome do Cliente / Responsável
                      </React.Fragment>
                    )}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="responsavel"
                    
                    name="responsavel"
                    defaultValue={this.state.responsavel}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="tecnico">Nome do Técnico</label>
                  <input
                    type="text"
                    className="form-control"
                    id="tecnico"
                    name="tecnico"
                    
                    defaultValue={this.state.tecnico}
                    readOnly
                  />
                </div>
              </div>
            </div>

            {this.state.status === "concluido" && (
              <React.Fragment>
                <div className="d-flex justify-content-center">
                  <div className="p-2 bd-highlight align-self-center">
                    <i
                      className="fas fa-check-circle fa-2x"
                      style={{ color: "green" }}
                    />
                  </div>
                  <div className="p-2 bd-highlight align-self-center">
                    <b> Rat Concluída</b>
                  </div>
                  <div className="card marginTop6">
                    <a
                      className="btn btn-success"
                      href={
                        "https://noc.all.com.br/pdfAtividade/pdfRatClient.php?id=" +
                        this.props.match.params.id
                      }
                      role="button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Enviar E-mail
                    </a>
                  </div>
                </div>
              </React.Fragment>
            )}         
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ActivityClientNoEdit;
